import { isArray, isEmptyString } from "@brg/is";

const nameUtils = {
  //@ts-ignore
  getFullName: function (profile, defName, defSurName) {
    //@ts-ignore
    var detect = function (v, def) {
      if (!v || isEmptyString(v) || isArray(v))
        return def;
      return v;
    };
    if (profile)
      return [detect(profile.name, defName), detect(profile.surName, defSurName)];
    return [defName, defSurName];
  },

  //@ts-ignore
  getFullNameString: function (profile, defName, defSurName) {
    return nameUtils.getFullName(profile, defName, defSurName).join(' ');
  },
}

export default nameUtils;import { isArray, isEmptyString } from "@brg/is";

const nameUtils = {
  //@ts-ignore
  getFullName: function (profile, defName, defSurName) {
    //@ts-ignore
    var detect = function (v, def) {
      if (!v || isEmptyString(v) || isArray(v))
        return def;
      return v;
    };
    if (profile)
      return [detect(profile.name, defName), detect(profile.surName, defSurName)];
    return [defName, defSurName];
  },

  //@ts-ignore
  getFullNameString: function (profile, defName, defSurName) {
    return nameUtils.getFullName(profile, defName, defSurName).join(' ');
  },
}

export default nameUtils;